/* CopyIconButton.tsx generated by @compiled/babel-plugin v0.36.1 */
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { useIntl } from 'react-intl-next';
import { IconButton } from '@atlaskit/button/new';
import CopyIcon from '@atlaskit/icon/core/copy';
import messages from './messages';
export var CopyIconButton = function CopyIconButton(_ref) {
  var onClick = _ref.onClick,
    tabIndex = _ref.tabIndex,
    appearance = _ref.appearance,
    spacing = _ref.spacing;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _React$useState = React.useState(formatMessage(messages.copy)),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    tooltip = _React$useState2[0],
    setTooltip = _React$useState2[1];
  var updateTooltip = React.useRef();
  var handleOnClick = React.useCallback(function (event) {
    onClick(event);
    setTooltip(formatMessage(messages.copiedToClipboard));
  }, [onClick, formatMessage]);
  var resetTooltip = React.useCallback(function () {
    return setTooltip(formatMessage(messages.copy));
  }, [formatMessage]);
  React.useLayoutEffect(function () {
    var _updateTooltip$curren;
    (_updateTooltip$curren = updateTooltip.current) === null || _updateTooltip$curren === void 0 || _updateTooltip$curren.call(updateTooltip);
  }, [tooltip]);
  var tooltipOptions = {
    position: 'top',
    content: function content(_ref2) {
      var update = _ref2.update;
      updateTooltip.current = update;
      return tooltip;
    },
    onHide: resetTooltip
  };
  return /*#__PURE__*/React.createElement(IconButton, {
    testId: "copy-response-button",
    type: "button",
    onClick: handleOnClick,
    icon: CopyIcon,
    label: tooltip,
    appearance: appearance,
    spacing: spacing,
    tabIndex: tabIndex,
    isTooltipDisabled: false,
    tooltip: tooltipOptions
  });
};